import {
    FETCHED_IMAGE_SETTINGS,
    FETCHED_SECTION_SETTINGS,
    FETCHED_SECTIONS_VIDEO_SETTINGS
} from './types';

export function fetchedSectionSettings(response) {
    return {
        type: FETCHED_SECTION_SETTINGS,
        payload: {
            sectionSettings: response
        }
    };
}

export function fetchedImageSettings(response) {
    return {
        type: FETCHED_IMAGE_SETTINGS,
        payload: {
            imageSettings: response
        }
    };
}

export function fetchedSectionsVideoSettings(response) {
    return {
        type: FETCHED_SECTIONS_VIDEO_SETTINGS,
        payload: {
            videoSettings: response
        }
    };
}


// WEBPACK FOOTER //
// ./src/containers/pages/settings/actions.js